<template>
  <ViewHeader />
  <Block>
    <p>{{ $t('routes.error404.text') }}</p>
  </Block>
</template>
